<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'">
                                <router-link :to="{path:'/admin/grupos'}">Grupos</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'"
                                style="text-transform: capitalize">
                                <router-link :to="{path:'/admin/grupos/'+sede}">{{sede}}</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'"
                                style="text-transform: capitalize">
                                <router-link :to="{path:'/admin/grupos/'+sede+'/'+dia}">{{dia}}</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'"
                                style="text-transform: capitalize">
                                <router-link :to="{path:'/admin/grupos/'+sede+'/'+dia+'/'+turno}">
                                    <span v-if="turno == 1">1º Turno</span>
                                    <span v-else>2º Turno</span>
                                </router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page">
                                <router-link :to="{path:'/admin/grupos/'+sede+'/'+dia+'/'+turno+'/'+group.id}">{{group |
                                    parseGrupo}}
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Crear entrenamiento
                            </li>
                        </ol>
                    </nav>
                </div>


                <div class="col-md-4" style="margin-bottom: 20px">
                    <label><strong>Fecha del entrenamiento</strong></label>
                    <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="configDate"
                                     class="form-control datepicker"
                                     v-model="entrenamiento.date">
                        </flat-picker>
                    </base-input>
                </div>

                <div class="col-md-12" style="margin-bottom: 20px">
                    <label><strong>Descripción del entrenamiento</strong></label>
                    <textarea id="" cols="10" rows="5" v-model="entrenamiento.descri" class="form-control"></textarea>
                </div>


                <div class="col-md-12" style="margin-bottom: 20px">

                    <label><strong>Listado de asistencia</strong></label>

                    <div class="card">
                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap" id="table-players">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Asistencia</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="player in entrenamiento.players">
                                    <th>
                                        <div class="media align-items-center">

                                            <img alt="Image placeholder" :src="player.img"
                                                 class="avatar rounded-circle mr-3">

                                            <div class="media-body">
                                                <span class="name mb-0 text-sm" id="name-player">{{player.apellidos | capitalizeText}}, {{player.nombre | capitalizeText}}</span>
                                            </div>
                                        </div>

                                    </th>

                                    <td class="align-middle">
                                        <base-checkbox v-model="player.asistencia">
                                            <span>Asistencia</span>
                                        </base-checkbox>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <button class="btn btn-success" @click="saveEntrenamiento">
                        <i class="fas fa-check"></i> Guardar entrenamiento
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
    import flatPicker from "vue-flatpickr-component";
    import {Spanish} from 'flatpickr/dist/l10n/es'
    import "flatpickr/dist/flatpickr.css";


    export default {
        data() {
            return {
                sede: this.$route.params.sede,
                dia: this.$route.params.dia,
                turno: this.$route.params.turno,
                type: this.$store.getters.type,
                group: {},
                entrenamiento: {
                    date: "today",
                    descri: "",
                    players: {}
                },
                configDate: {
                    allowInput: false,
                    altFormat: 'd-m-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: Spanish
                },
            };
        },
        components: {flatPicker},
        directives: {
            'b-tooltip': BTooltipDirective
        },
        created() {
            this.loadGroup();
            this.loadPlayers();
        },
        methods: {
            loadGroup() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'groups/' + this.$route.params.id, {
                    params: {
                        jwt: vm.$store.getters.jwt
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.group = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            loadPlayers() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'groups/' + this.$route.params.id + '/players-entrenamiento', {
                    params: {
                        jwt: vm.$store.getters.jwt
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.entrenamiento.players = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            saveEntrenamiento() {

                if (this.entrenamiento.descri === "") {
                    swal({
                        title: 'Atención',
                        text: "Debe introducir la descripción del entrenamiento",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }
                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'trainings', {
                    groupId: vm.group.id,
                    entrenamiento: vm.entrenamiento,
                    jwt: this.$store.getters.jwt
                }).then(response => {
                    if (response.data.response) {
                        swal({
                            title: 'Atención',
                            text: "Entrenamiento guardado correctamente",
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'success'
                        });

                        this.$router.push("/admin/grupos/" + vm.sede + "/" + vm.dia + "/" + vm.turno + "/" + vm.group.id);

                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
        }

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .card {
        background-color: #f7fafc !important;
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
        border: 1px solid rgba(0, 0, 0, .05);
        border-radius: .375rem;
    }

    #table-players tbody tr:hover {
        background-color: rgba(62, 92, 75, 0.3);
    }

    #table-players tbody tr:hover #name-player {
        text-decoration: underline;
    }


</style>
